import {
    CHECKOUT_MODAL,
    CLEAR_CART,
    ADD_TO_CART,
    ADD_TO_CART_SUCCESS,
    REMOVE_FROM_CART,
    REMOVE_FROM_CART_SUCCESS,
    GET_PRODUCTS,    
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    CHECKOUT,
    CHECKOUT_PRODUCTS_SUCCESS,
    CHECKOUT_ORDER_SUCCESS,
    UPDATE_PRODUCTS,
    UPDATE_PRODUCTS_SUCCESS
} from "../actions/store";

import Api from "src/services/Api";
import parser from '../../utils/parser';
  
const state = { 
    checkoutModalOpen: false,
    products: [],
    order: {}
};

const getters = {
    isCheckoutModalOpen: state => state.checkoutModalOpen,
    numProductsCart: (state) => {
        if(state.products.length > 0 && state.products[0] !=null){
            return state.products.filter(x => (x.isAddedToCart===true)).length;
        }
        return 0;
    },
    products: state => state.products,
    order: state => state.order,
    productsAdded: (state)=> {
        return state.products.filter(x => (x.isAddedToCart===true));
    },
    productsTotal: (state) =>{
        var t = 0;
        state.products.forEach(p=>{
            if(p.isAddedToCart){
                t+=p.price;
            }
        });
        return t;
    }    
}

const actions = {
    [ADD_TO_CART] : ({commit}, data) => {
        return new Promise((resolve, reject) => {            
            for(var i=0;i<state.products.length;i++){
                if(state.products[i].id === data.id){                    
                    commit(ADD_TO_CART_SUCCESS,i);
                    resolve(state.products[i]);
                }
            }
            reject(null);
        });
    },
    [CLEAR_CART] : ({commit}) => {
        return new Promise((resolve) => {          
            for(var i=0;i<state.products.length;i++){
                if(state.products[i].isAddedToCart){                    
                    commit(REMOVE_FROM_CART_SUCCESS,i);
                }
            }           
            resolve(state.products);
        });
    },
    [REMOVE_FROM_CART] : ({commit}, data) => {        
        return new Promise((resolve, reject) => {
            for(var i=0;i<state.products.length;i++){
                if(state.products[i].id === data.id){                    
                    commit(REMOVE_FROM_CART_SUCCESS,i);
                    resolve(state.products[i]);
                }
            }
            reject(null);
        });
    },
    [GET_PRODUCTS] : ({commit}, data) => {
        return new Promise((resolve, reject) =>{
            Api.getMyProducts(data.token)
            .then(response=>{    
                var productList = parser.getMyProductsToProducts(response);     
                var added = state.products.filter(x => (x.isAddedToCart===true));
                added.forEach(a=>{
                    productList.forEach(p=>{
                        if(a.id == p.id){
                            p.isAddedToCart = true;
                        }
                    })
                }); 
                state.products = productList;
                commit(GET_PRODUCTS_SUCCESS,productList)
                resolve(state.products);
            })
            .catch(()=>{
                commit(GET_PRODUCTS_FAIL);
                reject(null);
            })
        });
    },
    [UPDATE_PRODUCTS] : ({commit}, data) =>  {
        return new Promise((resolve, reject) => {
            var productList =  state.products;
            if(productList==null){
                reject(null);
            }
            var updated = false;
            data.forEach(updatedProduct => {
                productList.forEach(product=>{         
                    if(updatedProduct.id == product.id){
                        product = updatedProduct;
                        updated = true;
                    }
                })
            });
            if(updated){
                commit(UPDATE_PRODUCTS_SUCCESS, productList);
                resolve(state.products);
            }else{
                reject(null);
            }
        });
    },
    [CHECKOUT] : ({commit}, data) =>{
        return new Promise((resolve, reject) =>{            
            Api.completeSell(data.token, data.products, data.order.id)
                .then((resp)=>{    
                    var order = parser.getMyOrderToOrder(resp);
                    var products = [];
                    for(var i=0;i<state.products.length;i++){
                        var isOnCart = false;
                        data.products.forEach((cartProduct)=>{
                            if(state.products[i].id == cartProduct.id){
                                isOnCart = true;
                            }
                        });
                        if(!isOnCart){
                            products.push(state.products[i]);
                        }
                    }                   
                    state.order = order;
                    commit(CHECKOUT_ORDER_SUCCESS, order);
                    commit(CHECKOUT_PRODUCTS_SUCCESS, products);
                    resolve(state.products);
                })
                .catch(()=>{
                    reject(null);
                })            
        })
    }
}

const mutations = {    
    [CHECKOUT_MODAL]: (state,status) => {
        state.checkoutModalOpen = status;
    },
    [ADD_TO_CART_SUCCESS]: (state,index) => {
        state.products[index].isAddedToCart = true;
    },
    [REMOVE_FROM_CART_SUCCESS]: (state,index) => {
        state.products[index].isAddedToCart = false;
    },
    [GET_PRODUCTS_SUCCESS]: (state, products) =>{               
        state.products = products;
    },
    [GET_PRODUCTS_FAIL]: (state) =>{
        state.products = [];
    },
    [CHECKOUT_PRODUCTS_SUCCESS]: (state, products) =>{
        state.products = products;
    },
    [CHECKOUT_ORDER_SUCCESS]: (state, order) =>{
        state.order = order;
    },
    [UPDATE_PRODUCTS_SUCCESS]: (state, products) => {
        state.products = products;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};